<template>
  <div v-if="computedTabType" class="casino-tabs-container" ref="tabsContainer" :class="[section]">
    <v-tabs v-model="selectedTab" @change="onTabChange" ref="vTabs">
      <div class="tabs-wrapper">
        <!-- Hidden dummy tab -->
        <v-tab v-if="['filterAndSort'].includes(section)" class="dummy-tab"></v-tab>

        <template v-if="!['filterAndSort'].includes(section)">
          <v-tab
            class="tab-item"
            :class="[{'tab-disabled': itemCount === 0}, n]"
            v-for="(n, index) in computedTabType"
            :key="n"
            :ripple="false"
            :ref="el => tabRefs[index] = el">
            {{ $t(tabsTranslation[n]) }}
          </v-tab>
        </template>

        <template v-else>
          <template v-for="(n, index) in computedTabType">
            <template v-if="n === 'FilterBy'">
              <v-tab
                :key="n"
                class="tab-item"
                :class="[{'tab-disabled': itemCount === 0}, n]"
                :ripple="false"
                :ref="el => tabRefs[index] = el"
                @click="openDrawer(index, n)">
                <span class="tab-icon" :class="[n]"></span>
                <span v-if="!mobileBigAndBelow" class="tab-text">{{ $t(tabsTranslation[n]) }}</span>
                <v-icon v-if="activeKey === n">expand_less</v-icon>
                <v-icon v-else>expand_more</v-icon>
              </v-tab>
            </template>
            <template v-else>
            <v-menu
              :key="n"
              transition="none"
              v-model="menuStates[index]"
              :close-on-content-click="false"
              @input="handleMenuToggle($event, index)"
              :offset-overflow="true"
              offset-y
              :nudge-bottom="10"
              :nudge-left="calculateMenuPosition(index, n)"
              :max-width="n === 'RemoveAllFavorites' ? 250 : 200"
              :disabled="itemCount === 0"
              content-class="casino-tab-menu"
            >
              <template v-slot:activator="{ on }">
                <v-tab
                  class="tab-item"
                  :class="[{'tab-disabled': itemCount === 0}, n]"
                  :ripple="false"
                  :ref="el => tabRefs[index] = el"
                  v-on="on"
                  @click="onTabClick(index, n)">
                  <span class="tab-icon" :class="[n]"></span>
                  <span v-if="!mobileBigAndBelow" class="tab-text">{{ $t(tabsTranslation[n]) }}</span>
                  <span v-if="!['RemoveAllFavorites'].includes(n)">
                    <v-icon v-if="activeKey === n">expand_less</v-icon>
                    <v-icon v-else>expand_more</v-icon>
                  </span>
                </v-tab>
              </template>

              <filter-and-sort-panel
                :activeKey="n"
                :itemCount="itemCount"
                :providers="providers"
                :themeList="themeList"
                :filteredItems="filteredItems"
                :originalPreparedData="originalPreparedData"
                @close="closeMenu(index)"
                @sortTypeSelected="handleSortTypeSelected"
                @filterSelected="handleFilterSelected"
                :pageSection="pageType"
              ></filter-and-sort-panel>
            </v-menu>
          </template>
          </template>
        </template>
      </div>
    </v-tabs>

    <v-navigation-drawer
      v-model="filterDrawer"
      :right="true"
      temporary
      fixed
      :width="drawerWidth"
      class="filter-drawer"
    >
      <filter-and-sort-panel
        activeKey="FilterBy"
        :itemCount="itemCount"
        :providers="providers"
        :themeList="themeList"
        :filteredItems="filteredItems"
        :originalPreparedData="originalPreparedData"
        :selectedFilterNumberDisplay="selectedFilterNumberDisplay"
        @close="filterDrawer = false"
        @sortTypeSelected="handleSortTypeSelected"
        @filterSelected="handleFilterSelected"
        :pageSection="pageType"
      />
    </v-navigation-drawer>
  </div>
</template>

<script>
import Casino from '@/components/mixins/Casino'
import Screen from '@/components/mixins/Screen'
import FilterAndSortPanel from '@/components/igaming/partials/filterAndSortPanel.vue'

export default {
  name: 'casinoTabs',
  props: ['section', 'setDefaultTab', 'pageType', 'itemCount', 'providers', 'themeList', 'filteredItems', 'originalPreparedData', 'selectedFilterNumberDisplay'],

  mixins: [Casino, Screen],

  components: {
    FilterAndSortPanel
  },

  data () {
    return {
      tabType: false,
      userSection: ['RecentlyPlayed', 'RecommendedGames', 'FavoriteGames'],
      filterAndSort: ['SortBy', 'FilterBy', 'RemoveAllFavorites'],
      tabIcons: ['SortBy', 'FilterBy'],
      selectedTab: 0,
      tabRefs: [],
      activeKey: false,
      tabsTranslation: {
        'RecentlyPlayed': 'Casino.User.Recently.Played.Games',
        'RecommendedGames': 'Casino.User.Recommended.Games',
        'FavoriteGames': 'Casino.User.Favorite.Games',
        'SortBy': 'Casino.SortBy',
        'FilterBy': 'Casino.FilterBy',
        'RemoveAllFavorites': 'Casino.RemoveAllFavorites'
      },
      menuStates: [],
      filterDrawer: false
    }
  },

  computed: {
    computedTabType () {
      if (Array.isArray(this.section)) return this.section
      if (typeof this.section === 'string' && this[this.section]) {
        let section = this[this.section]
        if (this.pageType !== 'favorite-games' && this.section === 'filterAndSort') {
          section = this.filterAndSort.filter(
            item => item !== 'RemoveAllFavorites'
          )
        }
        return section
      }
      return []
    },
    drawerWidth () {
      if (this.mobileBigAndBelow) {
        return window.innerWidth * 0.9
      }
      return 400
    }
  },

  methods: {
    onTabClick (index, key) {
      if (this.itemCount === 0) return
      this.activeKey = key
      this.$emit('tabChanged', key)
    },

    onTabChange () {
      if (this.itemCount === 0) return false
      if (['filterAndSort'].includes(this.section) && this.selectedTab === 0) return false
      let activeKeyIndex = this.selectedTab
      if (['filterAndSort'].includes(this.section)) {
        activeKeyIndex = this.selectedTab - 1
      }

      const activeKey = this.computedTabType[activeKeyIndex]
      this.activeKey = activeKey
      this.$emit('tabChanged', activeKey)

      if (!this.mobileBigAndBelow) return false

      this.$nextTick(() => {
        const activeTab = this.tabRefs[activeKeyIndex] && this.tabRefs[activeKeyIndex].$el
        if (activeTab) {
          activeTab.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
          })
        }
      })
    },

    openDrawer (index, key) {
      if (this.itemCount === 0) return

      this.selectedTab = index + 1
      this.activeKey = key
      this.filterDrawer = true
      this.$emit('tabChanged', key)
    },

    closeMenu (index) {
      this.$set(this.menuStates, index, false)
      this.$nextTick(() => {
        this.selectedTab = 0
        this.activeKey = false
      })
    },

    closeAllMenus () {
      this.menuStates = this.menuStates.map(() => false)
      this.filterDrawer = false
    },

    handleFilterSelected (data) {
      this.$emit('filterSelected', data)
    },

    handleSortTypeSelected (sortOrder) {
      this.$emit('sortTypeSelected', sortOrder)
    },

    resetAll () {
      this.selectedTab = 0
      this.closeAllMenus()
      this.tabRefs = []
      this.activeKey = false
    },
    handleMenuToggle (isOpen) {
      if (!isOpen) {
        this.$nextTick(() => {
          this.selectedTab = 0
          this.activeKey = false
        })
      }
    },

    calculateMenuPosition (index, key) {
      const tab = this.tabRefs[index] && (this.tabRefs[index].$el || this.tabRefs[index])
      const container = document.querySelector('.casinopage')

      if (!tab || !container) return 0

      const tabRect = tab.getBoundingClientRect()
      const containerRect = container.getBoundingClientRect()
      const panelWidth = key === 'RemoveAllFavorites' ? 250 : 200
      const panelRightEdge = tabRect.left + panelWidth
      if (panelRightEdge > containerRect.right) {
        const overflow = panelRightEdge - containerRect.right
        return overflow + 10
      }

      return 0
    }
  },

  mounted () {
    this.tabType = this.section
    if (['filterAndSort'].includes(this.section)) {
      this.selectedTab = 0
    } else {
      this.selectedTab = 0
      const activeKey = this.computedTabType[0]
      if (activeKey) {
        this.activeKey = activeKey
        this.$emit('tabChanged', activeKey)
      }
    }
    this.menuStates = new Array(this.computedTabType.length).fill(false)
  },

  beforeMount () {
    if (this.setDefaultTab) this.selectedTab = 1
  },

  beforeRouteLeave (to, from, next) {
    this.resetAll()
    next()
  },

  beforeDestroy () {
    this.resetAll()
  },

  watch: {
    filterDrawer (newVal) {
      if (!newVal && this.activeKey === 'FilterBy') {
        this.$nextTick(() => {
          this.selectedTab = 0
          this.activeKey = false
        })
      }
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/css/config'
@import '~@/css/mixins'

.casino-tabs-container
  display flex
  position relative

  &.filterAndSort
    justify-content flex-end

  .tabs-wrapper
    display flex

  .v-tabs
    width auto
    padding 6px 2px
    background var(--navigation-bgr)
    border-radius 30px
    text-transform none !important
    max-height: 48px

    @media mobile-big-and-below
      margin-top 10px
      padding 6px

    >>>.v-tabs__bar
      margin 0 !important

    >>>.v-tabs__container
      padding-left 0 !important
      padding-right 0 !important
      border-radius 30px
      background transparent !important
      height 35px !important
      overflow-x auto
      -webkit-overflow-scrolling touch

      &::-webkit-scrollbar
        display none

      -ms-overflow-style none
      scrollbar-width none
      white-space nowrap

      @media mobile-big-and-below
        height 30px !important

      .v-tabs__div
        flex 0 0 auto
        max-width 150px
        margin 0 5px
        z-index 1

        .v-tabs__item
          border: 1px solid transparent
          border-radius 30px
          color var(--tab-live-color) !important
          text-transform none !important
          padding 0 15px
          background-color var(--casino-container-bgr)
          .v-icon
            display flex !important
            color: #8E959A
            height: 20px
            width: 20px
            background-position: center
            margin-left 5px
          .tab-icon
            height: 20px
            width: 17px
            display: flex
            margin-right 10px
            @media mobile-big-and-below
              margin-right 0
            &.SortBy
              background-image var(--casino-sort-icon)
            &.FilterBy
              background-image var(--casino-filter-icon)
            &.RemoveAllFavorites
              background-image var(--casino-remove-icon)

          //&.v-tabs__item--active
          //  background var(--casino-tab-background-active) !important
          //  pointer-events none
          //  color var(--casino-container-bgr) !important
          //  .v-icon, .tab-icon
          //    color: var(--casino-container-bgr)

        //.v-tabs__item:hover
        //  border-radius 30px
        //  border 1px solid var(--side-nav-color-active)
        //  cursor pointer

  &.userSection
    .v-tabs
      >>>.v-tabs__container
        .v-tabs__item
          background-color unset
          &.v-tabs__item--active
            background var(--casino-tab-background-active) !important
            pointer-events none
            color var(--casino-container-bgr) !important
            .v-icon, .tab-icon
              color: var(--casino-container-bgr)

.dummy-tab
  display: none !important
  width: 0 !important
  height: 0 !important
  padding: 0 !important
  margin: 0 !important
  opacity: 0 !important
  pointer-events: none !important
  position: absolute !important

.filter-drawer
  z-index: 9999 !important

.casino-tab-menu
  border-radius: 10px
  background: var(--casino-game-info-bgr)
  color: var(--casino-game-info-color)
  opacity: 0.95
</style>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoTabs.vue